import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

import { Service } from '@/services/CatalogService.interface'
  // Import the ReservationOptionSection component for rendering the reservation options sections
  import ReservationOptionSection from './ReservationOptionSection.vue'

  interface OptionItem {
    options: Partial<Service>[] // Array of options for a section
    sectionTitle: string // Section title
    iconComponent: object // Vue component for the section's icon
  }

  // Props
  
export default /*@__PURE__*/_defineComponent({
  __name: 'OptionList',
  props: {
    options: {}
  },
  setup(__props: any) {

  // Import the Service type from the store types module
  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
      return (_openBlock(), _createBlock(ReservationOptionSection, {
        key: index,
        options: option.options,
        sectionTitle: option.sectionTitle,
        iconComponent: option.iconComponent
      }, null, 8, ["options", "sectionTitle", "iconComponent"]))
    }), 128))
  ]))
}
}

})